// extracted by mini-css-extract-plugin
module.exports = {"social_btn":"SocialButtons_social_btn__1IMry"};